class FormHandler {

  constructor(wrapperEl) {
    this.wrapper = wrapperEl
    this.form = wrapperEl.querySelector('form')
    this.successEl = wrapperEl.querySelector('.js-form-success')
    this.listen()
  }

  listen() {
    this.form.addEventListener('submit', async (e) => {
      e.preventDefault()
      this.clearErrors()

      const response = await fetch(this.form.action, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(this.form),
      })

      const data = await response.json()

      if (data.success) {
        this.form.classList.add('hidden')
        this.successEl.hidden = false
      } else if (data.errors) {
        this.showErrors(data.errors)
      }
    })
  }

  clearErrors() {
    this.wrapper.querySelectorAll('.js-field-error').forEach(el => {
      el.textContent = ''
      el.hidden = true
    })
  }

  showErrors(errors) {
    Object.entries(errors).forEach(([handle, messages]) => {
      const group = this.wrapper.querySelector(`[data-handle="${handle}"]`)
      if (!group) return
      const errorEl = group.querySelector('.js-field-error')
      if (!errorEl) return
      errorEl.textContent = messages[0]
      errorEl.hidden = false
    })
  }

}

export default FormHandler
